import { Endpoint } from "@rest-hooks/endpoint";
export function isErrorFromCalculation(res) {
    const e = res;
    return (e?.errors != null && e?.errors.length > 0) || e.error != null;
}
export const performBuyoutCalculation = async (values) => {
    const params = new URLSearchParams({
        registrationNumber: values.registrationNumber,
        buyoutDate: values.buyoutDate
    });
    if (values.mileage && values.mileage > 0) {
        params.append("mileage", values.mileage.toString());
    }
    const res = await fetch(`/buyout/GetBuyoutEvaluation?${params.toString()}`, {
        method: "GET"
    });
    if (res.ok)
        return res.json();
    return await res.json();
};
export const BuyoutCalculationEndpoint = new Endpoint(performBuyoutCalculation, {
    key({ registrationNumber, buyoutDate, mileage }) {
        return `buyout-calculation-${registrationNumber}-${buyoutDate}-${mileage}`;
    },
    dataExpiryLength: 1000 * 60
});
//# sourceMappingURL=BuyoutCalculation.js.map